<template>
  <div id="nav" class="position-fixed w-100 h-100 p-0">
    <div class="content position-absolute text-left h-100 overflow-auto">
      <div class="scrollable">
        <button ref="closemenu" type="button" class="close position-absolute" aria-label="Close">
          <i class="material-icons-round">close</i>
        </button>
        <div class="bg-gray pt-4 pb-3">
          <div class="text-center pt-2">
            <div v-if="user" class="position-relative">
              <span v-if="user.avatar" class="photo-comment">Looking good :-)</span>
              <span v-if="!user.avatar" class="photo-comment">Upload profielfoto</span>
              <img alt="arrow" src="../assets/arrow.png" class="arrow" />
              <div class="d-flex justify-content-center align-items-center">
                <router-link
                  :to="{
                    name: user.type == 2 ? 'company-edit' : 'applicant-edit'
                  }"
                  class="circle-icon edit"
                >
                  <span class="icon">
                    <i class="material-icons">edit</i>
                  </span>
                  <label>bewerk profiel</label>
                </router-link>

                <div class="d-block avatar rounded-circle position-relative overflow-hidden">
                  <router-link
                    v-if="user.avatar"
                    :to="{
                      name: user.type == 2 ? 'company-edit' : 'applicant-edit'
                    }"
                    class="d-block image_background"
                    :style="user ? this.ImageBackground($store.state.user_avatar):''"
                  ></router-link>
                  <router-link
                    v-if="!user.avatar"
                    :to="{
                      name: user.type == 2 ? 'company-step_1' : 'applicant-details',
                      params: user.type == 2 ? '' : { action: 'save'},
                    }"
                    class="d-block image_background"
                  ></router-link>
                </div>

                <router-link
                  :to="{
                    name:
                      user.type == 2 ? 'company-profile' : 'applicant-profile'
                  }"
                  class="circle-icon view"
                >
                  <span class="icon">
                    <i class="material-icons">remove_red_eye</i>
                  </span>
                  <label>bekijk profiel</label>
                </router-link>
              </div>
              <div>
                <div class="name">
                  <strong>{{ user.type == 2 ? user.name : user.firstname }}</strong>
                </div>
                <div class="position text mb-2">{{ user.type == 2 ? user.city : "" }}</div>
              </div>
            </div>

            <div v-else class="logo icon-wrapper">
              <svg-icon icon="derect_logo" />
            </div>
          </div>
        </div>
        <div class>
          <ul class="links list-unstyled">
            <template v-if="!user_token">
              <li><router-link :to="{ name: 'login' }">Login</router-link></li>
              <li><router-link :to="{ name: 'choose-branch' }">Nieuw hier?</router-link></li>
            </template>
            <template v-else>
              <li>
                <router-link :to="{ name: user.type == 2 ? 'company-dashboard' : 'applicant-dashboard'}">Dashboard</router-link>
              </li>
              <template v-if="user.type == 1">
                <!-- If user is candidate -->
                <li>
                  <router-link :to="{ name: 'jobs-match' }">
                    Matches
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'jobs-pending' }">
                    Sollicitaties
                  </router-link>
                </li>
                <li v-if="user.sub_branch !== '2' && user.branch != 3">
                  <router-link :to="{ name: 'jobs-approved' }">
                    Bevestigd
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'availability' }">
                    Beschikbaarheid
                  </router-link>
                </li>
              </template>
              <template v-if="user.type == 2">
                  <template v-if="user.branch == 3">
                    <li>
                      <router-link :to="{ name: 'company-healthcare-matches' }">
                        Matches
                      </router-link>
                    </li>
                  </template>
                  <template v-else>
                      <li>
                          <router-link :to="{ name: 'company-matches' }">
                              Matches
                          </router-link>
                      </li>
                  </template>
                <li>
                  <router-link :to="{ name: 'company-applicants' }">
                    Sollicitaties
                  </router-link>
                </li>
                <li v-if="user.sub_branch !== '2' && user.branch != 3">
                  <router-link :to="{ name: 'jobs-closed' }">
                    Bevestigd
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'jobs-open' }">
                    Vacatures
                  </router-link>
                </li>
              </template>
            </template>
            <li><router-link :to="{ name: 'about' }">Over Derect</router-link></li>
            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
            <li v-if="user_token"><a v-on:click="logoutUser">Uitloggen</a></li>
          </ul>
        </div>
        <div class="footer py-3 text-center position-absolute">
          <ul class="list-inline m-0">
            <li class="list-inline-item">
              <router-link :to="{ name: user.type == 1 ? 'applicant-terms' : user.type == 2 ?'company-terms' : 'terms' }" >Algemene voorwaarden</router-link>
            </li>
            <li class="list-inline-item">
              <router-link :to="{ name: 'privacy' }">Privacyverklaring</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      user_token: "",
      user: "",
      profession: "",
      navState: this.navHidden
    };
  },
  props: {
    addClass: {
      type: String,
      default: ""
    },
    navHidden: {
      type: Boolean,
      default: true
    }
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    navState: async function() {
      await this.fetchData();
    },
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.user_token = JSON.parse(localStorage.getItem("user-token"));
      this.user = JSON.parse(localStorage.getItem("user"));
      if (this.user_token == null) {
        this.user_token = "";
      }
      if (this.user == null) {
        this.user = "";
      }
      
      if (this.user) {
        this.$store.state.user_avatar = this.user.avatar;
        // there is no city in user json so i inject via first user address. --jimbo
      }
      if (this.user_token && this.user) {
        if (this.user.type == 1) {
          // if (this.user.search_profession_id) {
          //   this.profession = await this.getAPIList(
          //     "professions",
          //     this.user.search_profession_id
          //   );
          // } else {
          //   this.profession = "-";
          // }
        } else {
          this.user["city"] = this.user.addresses[0].city;
        }
        if (!this.user.city) {
          this.user.city = "Adres";
        }
      }
    },
    sortObj(obj) {
      const unordered = obj;
      const ordered = {};
      Object.keys(unordered)
        .sort()
        .forEach(function(key) {
          ordered[key] = unordered[key];
        });
      return ordered;
    }
  }
};
</script>

<style scoped>
#nav .content .close {
  position: fixed !important;
}
#nav .content .scrollable {
  padding-bottom: 52px;
  position: relative;
  min-height: 100%;
}
#nav .content::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #ffffff;
}

#nav .content::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f4f4;
}

#nav .content::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.5);
  background-color: #FFCD00;
}
#nav .content .footer li {
  margin: 0 5px;
}
</style>
